// this file gets replaced with the real value during the build
const Version = '6.6.0';

export { Version as default };
